module.exports = "/images/register_bg.jpg?4266969574f15fa4d6c3337f52b76320";